import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appVisibleContent]'
})
export class VisibleContentDirective {
  @Input() locationView: string;
  @Input() regionName: string;
  constructor(el: ElementRef) {
    // el.nativeElement.style.backgroundColor = 'yellow';
  }
  @HostListener('mouseleave')
  onMouseOver() {
    let index;
    if (this.regionName === 'portal_dashboard') {
    }

  }
   @HostListener('click')
   onClick() {
    let index;
    if (this.regionName === 'portal_product_detail_information'){
    }

   }

}
